module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACWSURBVHgB7ZPLDYAgEEQ3Nqol2IF0qB1oJyObaIIJwixw4MBL9qK78wgfkUF3AJh9nb42w8zqa9dZplkbX7IS7Qn6TyEGHL5sZLjihIGRFIczkurwlKRZeELSLjwjcczsJBwgv9mJ7Hn04FuFOxjeiTk8+FcnAXEViyUw3POIZGUEFxP+I9mFGFh8HTA8okeiC1tk0B03Hy7tR3jkT/IAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/Images/closeicon.png
// module id = 1147
// module chunks = 0